import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface Action {
  outputs: string[];
  inputs: { key: string; value: any }[];
  templateRef: Type<any>;
}

@Component({
  selector: 'sc-wrapper-card',
  templateUrl: './wrapper-card.component.html',
  styleUrls: ['./wrapper-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WrapperCardComponent extends FieldWrapper implements OnInit, OnDestroy {
  @ViewChild('content', { static: true, read: ViewContainerRef })
  content: ViewContainerRef;
  public componentRef: ComponentRef<WrapperCardComponent>;
  public templateId: string;
  private _unsubscribe$: Subject<void> = new Subject();

  constructor(private _cfr: ComponentFactoryResolver, private _cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.templateId = `card-${this.field.key}`;
    const action: Action = this.field.templateOptions.action;
    if (action && action.templateRef) {
      const cmpFactory: any = this._cfr.resolveComponentFactory(action.templateRef);
      this.componentRef = this.content.createComponent(cmpFactory);
      this.componentRef.changeDetectorRef.markForCheck();

      if (action.outputs) {
        action.outputs.forEach(output => {
          this.componentRef.instance[output].pipe(takeUntil(this._unsubscribe$)).subscribe(res => {
            this.field.templateOptions.actions[output](this.field, res);
            this._cd.markForCheck();
          });
        });
      }

      if (action.inputs) {
        action.inputs.forEach(input => {
          this.componentRef.instance[input.key] = input.value;
          this.componentRef.instance['field'] = this.field;
        });
      }
      this._cd.markForCheck();
    }
  }

  public ngOnDestroy() {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
